import { Input, Output, EventEmitter, SimpleChanges, Component,input } from '@angular/core';
import { CommonModule, } from '@angular/common';
import { FormsModule, FormArray, } from '@angular/forms';
import { ClickedOutsideDirective } from '../../directives/clicked-outside.directive';
import { ttd_endpoint } from '../../../app/data/api-endpoint/ttd-endpoint';
import { ContentMapperService } from '../../../app/core/services/content-mapper-service';

@Component({
  selector: 'app-multi-level-dropdown',
  imports: [CommonModule, FormsModule, ClickedOutsideDirective],
  templateUrl: './multi-level-dropdown.html',
  styleUrl: './multi-level-dropdown.scss'
})
export class MultiLevelDropdown {

 

  @Input() items: any[] = [];
  @Input() selectItems?: FormArray
  @Input() title: string = ''
  @Input() isSubmitted: boolean = false
  @Input() selectAll: boolean = true


  customWidth = input<boolean>(true);
  categoryIds = input<Set<number>>(new Set());


  @Output() itemChange = new EventEmitter<any>();
  @Output() selectAllChange = new EventEmitter<any>();
  @Output() clearAll = new EventEmitter<void>();
  @Output() removeItem = new EventEmitter<number>();


  OrginalCategories: any[] = [];
  filteredCategoryOptions: any[] = [];
  isDropdownOpen = false;
  showCustomCateogory: boolean = false
  searchTerm = '';
  customCategory: string = ''
  debounceTimeout: any
  currentIndex: any
  filterQuery: any
  addNew = 'assets/img/add-new.svg';
  cross = 'assets/img/cross.png';
  tick = 'assets/img/tick.svg';


  constructor(private _contentMapper: ContentMapperService) {

  }


  ngOnChanges(changes: SimpleChanges): void {
    if (changes['items'] && changes['items'].currentValue) {
      this.filteredCategoryOptions = structuredClone(this.items);
      this.OrginalCategories = structuredClone(this.items);
      this.filteredCategoryOptions.forEach((item: any) => this.patchCategorySelection(item));
    }
  }


  private patchCategorySelection(item:any): void {
    if(!item) return;
    const selectedValues = Array.isArray(this.selectItems?.value) ? this.selectItems.value : [];
    item.isSelected = selectedValues.includes(item.name);

    if(!item.isSelected){
      item.indeterminate = item.children?.some((child: any) => selectedValues.includes(child.name));
    }
    item.children.forEach((child: any) => this.patchCategorySelection(child));
  }


  toggleDropdown(): void {
    this.isDropdownOpen = !this.isDropdownOpen
  }

  getFilteredOptions() {
    return this.filteredCategoryOptions;
  }

  closeDropdown() {
    this.isDropdownOpen = false;
  }

  onSearch(e: Event): void {
    const value = (e.target as HTMLInputElement).value;
    this.searchTerm = value
    clearTimeout(this.debounceTimeout);
    this.debounceTimeout = setTimeout(() => {
      if(!this.searchTerm || this.searchTerm.trim().length < 2) {
        this.filteredCategoryOptions = structuredClone(this.OrginalCategories);
        this.filteredCategoryOptions.forEach((item: any) => this.patchCategorySelection(item));

        return;
      }
      this.fetchCategoriesBySearch(this.searchTerm);
    }, 500);
  }


  fetchCategoriesBySearch(term: string) {
    this._contentMapper.get(ttd_endpoint.custom_categories + `/search?q=${term.trim()}`).subscribe({
      next: (res: any) => {
        this.filteredCategoryOptions = res?.results || [];
        this.filteredCategoryOptions.forEach((item: any) => this.patchCategorySelection(item));

      },
      error: (err: any) => {
        console.error('Error fetching categories:', err);
      }
    }); 
  }


  onSelectAllChanged(event: Event,items:any) {
    const isChecked = (event.target as HTMLInputElement).checked;
    const categorySet = new Set<string>();
    items.forEach((item: any) =>  this.updateChildrenSelection(item, isChecked,categorySet));
    this.selectAllChange.emit({ event,  categorySet });
  }

  onClearAll(items:any= []) {
    const categorySet = new Set<string>();
    items.forEach((item: any) =>  this.updateChildrenSelection(item, false, categorySet));
    this.clearAll.emit();
  }

  removeItemFromArray(index: number) {
    this.isDropdownOpen = false
    this.removeItem.emit(index);
  }

  private updateChildrenSelection(item: any, isChecked: boolean,categorySet:Set<string>): void {
    if (!item) return;
    item.isSelected = isChecked;

    if(!isChecked){
      item.indeterminate = false;
    }

    if(isChecked){
      categorySet.add(item.name);
    }else{
      categorySet.delete(item.name);
    }

    if(!item.children?.length) return;
    item.children.forEach((child: any) => this.updateChildrenSelection(child, isChecked,categorySet));
  }

  onOptionChanged(e: Event, option: any) {
    const categorySet = new Set<string>(this.selectItems?.value || []);
    const isChecked = (e.target as HTMLInputElement).checked;
    this.updateChildrenSelection(option, isChecked,categorySet);
    this.itemChange.emit({ event: e, data: categorySet, level: 'greatParent' });
  }

  onChildChanged(e: Event, child: any, option: any) {
    const isChecked = (e.target as HTMLInputElement).checked;
    const categorySet = new Set<string>(this.selectItems?.value || []);
    this.updateChildrenSelection(child, isChecked,categorySet);

    const { allSelected,someSelected } = this.checkChildrenSelection(option.children);
    option.isSelected = allSelected;
    option.indeterminate = someSelected;

    if(allSelected){
      categorySet.add(option.name);
    }else{
      categorySet.delete(option.name);
    }

    this.itemChange.emit({ event: e, data: categorySet, level: 'parent' });
  }

  onSubChildChanged(e: Event, subChild: any, child: any, option: any) {
    const isChecked = (e.target as HTMLInputElement).checked;
    const categorySet = new Set<string>(this.selectItems?.value || []);

 
    this.updateChildrenSelection(subChild, isChecked, categorySet);

    const { allSelected,someSelected:someChildSelected } = this.checkChildrenSelection(child.children);
    child.isSelected = allSelected;
    child.indeterminate = someChildSelected;

    const { allSelected:allChildChecked,someSelected:someOptionSelected } = this.checkChildrenSelection(option.children);

    option.isSelected = allChildChecked;
    option.indeterminate = someOptionSelected || someChildSelected;

    if(allChildChecked){
      categorySet.add(option.name);
    }else{
      categorySet.delete(option.name);
    }
    this.itemChange.emit({ event: e, data: categorySet, level: 'child' });
  }

  onGrandChildChanged(e: Event, grandChild: any, subChild: any, child: any, option: any) {
    const isChecked = (e.target as HTMLInputElement).checked;
    const categorySet = new Set<string>(this.selectItems?.value || []);

   
    this.updateChildrenSelection(grandChild, isChecked, categorySet);

    const { allSelected:allGrandChildChecked,someSelected:someGrandChildSelected } = this.checkChildrenSelection(subChild.children);
    subChild.isSelected = allGrandChildChecked;
    subChild.indeterminate = someGrandChildSelected;


    if(allGrandChildChecked){
      categorySet.add(subChild.name);
    }else{
      categorySet.delete(subChild.name);
    }

    const { allSelected:allSubChildChecked,someSelected:someSubChildSelected } = this.checkChildrenSelection(child.children);

    child.isSelected = allSubChildChecked;
    child.indeterminate =  someSubChildSelected || someGrandChildSelected;

    if(allSubChildChecked){
      categorySet.add(child.name);
    }else{
      categorySet.delete(child.name);
    }

    const { allSelected:allChildChecked,someSelected:someOptionSelected } = this.checkChildrenSelection(option.children);

    option.isSelected = allChildChecked;
    option.indeterminate = someOptionSelected ||  someSubChildSelected || someGrandChildSelected;

    if(allChildChecked){
      categorySet.add(option.name);
    }else{
      categorySet.delete(option.name);
    }

    this.itemChange.emit({ event: e, data: categorySet, level: 'grandChild' });
  }



  private checkChildrenSelection(items: any[]): { allSelected: boolean, someSelected: boolean } {
    let allSelected = true;
    let someSelected = false;
    
    for (const item of items) {
      if (item.isSelected) {
        someSelected = true;
      } else {
        allSelected = false;
      }
      if (someSelected && !allSelected) break;
    }
    
    return { allSelected, someSelected };
  }

  isAllChecked() {
    const items = this.getFilteredOptions();
    return items.every((item: any) => item.isSelected);
  }

  ngOnDestroy(): void {
    if (this.debounceTimeout) {
      clearTimeout(this.debounceTimeout);
    }
  }

}
